module.exports = __webpack_public_path__ + "static/media/title.d0d5d8c0.png";